// @ts-nocheck
import { useCallback } from 'react';
import axios from 'axios';
import API_ENDPOINTS from '../../const/ApiEndPoints';
import useNote from './useNote';
import useEntity from './useEntity';
import useTeam from './useTeam';
import useDocument from './useDocument';
import useAlert from './useAlert';
import useVersion from './useVersion';
import useLog from './useLogs';
import useAttribute from './useAttribute';
import useAssociation from './useAssociation';
import useFilter from './useFilter';
import useSummary from './useSummary';
export default function useModelInventory() {
  const {
    addNote,
    deleteNote,
    editNote,
    getAllNotes,
    getLifecycleNotes,
    editLifecycleNote,
    getNoteReplies,
    searchMentionEntities,
    getAttributeComments,
  } = useNote();
  const {
    getAllModelEntity,
    allModelList,
    setAllModelList,
    createModelThirdStep,
    createModelForthStep,
    createModelSecondStep,
    createModelFirstStep,
    deleteModelEntity,
    getSingleEntityDetails,
    updateModelEntity,
    isEntityAvailable,
    integrateEntity,
    getSearchList,
    archiveEntity,
    downloadEntitiesReport,
    getEntityStatuses,
    linkedEntities,
    updateLinkedEntitiesColumnConfig,
    getLinkedTemplateEntities,
    getAllModelEntityLite,
    postAllModelEntityLite,
    getEntityAttributeKeysList,
    getEntityAttributeValuesList,
  } = useEntity();
  const {
    teamDetails,
    getTeamDetails,
    addSingleTeamMember,
    removeTeamMember,
    addSubRoles,
    updateUserDetails,
  } = useTeam();
  const {
    deleteAttchedDocument,
    attachDocument,
    getDocumentTree,
    fetchDocumentDetails,
    fetchDocumentsList,
    documentTree,
    docTableRowCount,
    docPageCount,
    setDocTableRowCount,
    setDocPageCount,
    documentsList,
    downloadReportDocument,
    editDocument,
    getAssociatedDocument,
    getAttributeDocument,
  } = useDocument();
  const {
    getAlertEvents,
    createAlerts,
    deleteAlert,
    updateAlerts,
    getAllAlerts,
  } = useAlert();
  const { rollbackVersion, getVersionsComparison, getVersions } = useVersion();
  const {
    getLogActionsAttributes,
    getLogActions,
    downloadLogs,
    getHistory,
    getLogstates,
  } = useLog();
  const {
    getAttributeDetails,
    getFieldsDataTypes,
    getMappedData,
    getOverrideAttributeValue,
  } = useAttribute();
  const {
    getAssociationDetails,
    removeModelAssociation,
    getTemplateAssociations,
    getParentAssociation,
    associationDetails,
  } = useAssociation();
  const { saveFilter, editFilter, deleteFilter } = useFilter();
  const {
    getStateDetails,
    getShowInSummary,
    getModelPreviousState,
    reclaimState,
    getModelStatus,
    sendForApproval,
    forceSendForApproval,
    getChartLink,
    getModelLinage,
    getWorkflowCheckList,
    changeWorkflowCheckList,
    getTransitionStates,
    getIssueTypesInfo,
    updateArtifactCycleCount,
    getApprovalDetails,
    freezeState,
    cycleSidebarData,
    isCycleProcessEnabled,
    getRaiseRequestForEntity,
    approveSegmentTransition,
  } = useSummary();
  const getUserRolePermissions = (params, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_USER_ROLE_PERMISSIONS}`,
        { params, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getAllAssociations = (params) =>
    axios.get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_ALL_ASSOCIATIONS}`,
      { params }
    );

  const getDownstreamEntities = (params, loader = true) =>
    axios.get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.DOWNSTREAM_ENTITIES}`,
      { params, loader: loader }
    );

  const getUpstreamDownstreamEntities = (params) =>
    axios.get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_DOWNSTREAM_UPSTREAM_ENTITIES}`,
      { params, loader: false }
    );

  const cloneEntity = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.CLONE_ENTITY}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getEntitySectionPermissions = (params, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.SECTION_PERMISSIONS}`,
        { params, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getGroupDetails = (params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GROUP_DETAILS}`,
        { params, loader: false }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getImpactedAttributeData = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_IMPACTED_ATTRIBUTES_DATA}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const createBulkEntities = useCallback((body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.BULK_UPDATE.CREATE_BULK_ENTITIES}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  return {
    getAllModelEntity,
    createModelFirstStep,
    createModelSecondStep,
    createModelThirdStep,
    createModelForthStep,
    setAllModelList,
    allModelList,
    getAttributeDetails,
    getTeamDetails,
    teamDetails,
    getAssociationDetails,
    associationDetails,
    addSingleTeamMember,
    deleteModelEntity,
    sendForApproval,
    forceSendForApproval,
    removeTeamMember,
    removeModelAssociation,
    getSingleEntityDetails,
    fetchDocumentsList,
    documentsList,
    attachDocument,
    deleteAttchedDocument,
    getHistory,
    getAllNotes,
    getNoteReplies,
    addNote,
    saveFilter,
    deleteFilter,
    editFilter,
    getAllAlerts,
    deleteAlert,
    updateAlerts,
    createAlerts,
    updateModelEntity,
    getSearchList,
    getVersions,
    rollbackVersion,
    getVersionsComparison,
    editDocument,
    deleteNote,
    getChartLink,
    editNote,
    getModelStatus,
    getModelLinage,
    getWorkflowCheckList,
    changeWorkflowCheckList,
    getAlertEvents,
    isEntityAvailable,
    getDocumentTree,
    documentTree,
    docTableRowCount,
    docPageCount,
    setDocTableRowCount,
    setDocPageCount,
    getAssociatedDocument,
    getAttributeDocument,
    getFieldsDataTypes,
    integrateEntity,
    getStateDetails,
    getShowInSummary,
    getTemplateAssociations,
    getParentAssociation,
    getIssueTypesInfo,
    cycleSidebarData,
    isCycleProcessEnabled,
    updateArtifactCycleCount,
    getModelPreviousState,
    reclaimState,
    getTransitionStates,
    getLifecycleNotes,
    editLifecycleNote,
    searchMentionEntities,
    fetchDocumentDetails,
    getLogActions,
    getLogActionsAttributes,
    downloadLogs,
    getUserRolePermissions,
    getMappedData,
    downloadReportDocument,
    getAllAssociations,
    archiveEntity,
    downloadEntitiesReport,
    getEntityStatuses,
    getAttributeComments,
    getDownstreamEntities,
    getUpstreamDownstreamEntities,
    addSubRoles,
    getApprovalDetails,
    updateUserDetails,
    getLogstates,
    freezeState,
    cloneEntity,
    getEntitySectionPermissions,
    getOverrideAttributeValue,
    getGroupDetails,
    getImpactedAttributeData,
    getRaiseRequestForEntity,
    linkedEntities,
    updateLinkedEntitiesColumnConfig,
    getLinkedTemplateEntities,
    getAllModelEntityLite,
    postAllModelEntityLite,
    approveSegmentTransition,
    getEntityAttributeKeysList,
    getEntityAttributeValuesList,
    createBulkEntities,
  };
}
